<template lang="pug">
.collapseButtonComponent(
  :class="{collapsed: state}"
)
  ui-svg-icon.icon(name="chevron")
</template>

<script>
export default {
  props: {
    isCollapsed: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    state () {
      return this.isCollapsed
    }
  }
}
</script>

<style lang="sass" scoped>
.collapseButtonComponent
  width: 8*$u
  height: 8*$u
  border-radius: 99em
  border: 0.75*$u solid $cElements
  background-color: $cWhite
  padding: 1*$u
  cursor: pointer
  box-shadow: 0 $u $cDarkBackground
  transition: all $animationSpeed

  > .icon
    color: $cDarkGrey
    transform-origin: center
    transition: $animationSpeed linear
    transform: rotate(0deg)
    margin-top: 0.75*$u

  &:hover
    background-color: $cElements

  &.collapsed
    border-color: $cBlue
    background-color: $cBlue
    box-shadow: 0 $u $cDarkBlue

    > .icon
      color: $cWhite
      transform: rotate(-180deg)
      margin-top: 0

</style>
